import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';

import { setMonthlyDuration, setYearlyDuration } from '../../../actions';

import styles from './index.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';

function handleDurationChange(duration, onClickFunc) {
  trackV2({
    category: 'summit_upsell',
    page: 'cart',
    action: 'change_duration',
    properties: {
      duration
    }
  });

  onClickFunc();
}

export const DurationSelect = ({
  disabled,
  duration,
  handleSetYearlyDuration,
  handleSetMonthlyDuration,
  yearlyPercentOff
}) => (
  <div className={`${styles.durationSelect} btn-group`}>
    <label
      className={`${styles.durationBtn} btn btn-default`}
      htmlFor="duration-yearly"
    >
      <input
        id="duration-yearly"
        type="radio"
        name="duration"
        checked={duration === 'yearly'}
        disabled={disabled}
        onChange={() => handleDurationChange('yearly', handleSetYearlyDuration)}
      />
      <p className={styles.durationText}>
        {I18n.t(`${I18nPrefix}.yearly`)}
        <span className={styles.yearlyPercentOff}>
          {I18n.t(`${I18nPrefix}.saving`, {
            percent: Math.round(yearlyPercentOff)
          })}
        </span>
      </p>
    </label>
    <label
      className={`${styles.durationBtn} btn btn-default`}
      htmlFor="duration-monthly"
    >
      <input
        id="duration-monthly"
        type="radio"
        name="duration"
        checked={duration === 'monthly'}
        disabled={disabled}
        onChange={() =>
          handleDurationChange('monthly', handleSetMonthlyDuration)
        }
      />
      <p className={styles.durationText}>{I18n.t(`${I18nPrefix}.monthly`)}</p>
    </label>
  </div>
);

DurationSelect.propTypes = {
  disabled: PropTypes.bool.isRequired,
  duration: PropTypes.string.isRequired,
  yearlyPercentOff: PropTypes.number.isRequired,
  handleSetMonthlyDuration: PropTypes.func.isRequired,
  handleSetYearlyDuration: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  disabled:
    state.checkout_submitting ||
    state.promo_code_submitting ||
    state.products.promotion.full,
  duration: state.duration,
  yearlyPercentOff: state.yearly_percent_off
});

export default connect(
  mapStateToProps,
  {
    handleSetMonthlyDuration: setMonthlyDuration,
    handleSetYearlyDuration: setYearlyDuration
  }
)(DurationSelect);
